/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./detailPublicMap.vue?vue&type=template&id=0fb31990&scoped=true"
import script from "./detailPublicMap.vue?vue&type=script&lang=js"
export * from "./detailPublicMap.vue?vue&type=script&lang=js"
import style0 from "./detailPublicMap.vue?vue&type=style&index=0&id=0fb31990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb31990",
  null
  
)

export default component.exports